module.exports = __webpack_public_path__ + "static/media/Kurt.299279c5.jpg";